import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import CreateNmsMeetingPage from '../CreateNmsMeetingPage';
import { NmsMeetingType } from '../CreateNmsMeetingPage/types';

export const EditNmsMeetingPage = () => {
  const [currentNmsMeetingState, setCurrentNmsMeeting] = useState<NmsMeetingType | null>(null);
  const { id } = useParams();

  useEffect(() => {
    if (id)
      (async () => {
        try {
          const response = await api.get<NmsMeetingType>(endpoints.getNmsById(id));

          setCurrentNmsMeeting(response.data);
        } catch (err) {}
      })();
  }, [id]);

  return <CreateNmsMeetingPage currentNmsMeeting={currentNmsMeetingState} id={id} editNmsMeeting />;
};
